import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TabsModel } from './tabs.types';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnInit {
  @Input() model: TabsModel = {
    tabs: [],
    activeTabIndex: 0,
  };

  @Output() tabClicked = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {
    return;
  }

  onTabClicked(tabIndex: number): void {
    this.tabClicked.next(tabIndex);
  }
}
